const fetchStatement = async (account: any) => {
  let acc_no = "";

  let no = account?.toString().length;

  switch (no) {
    case 1:
      acc_no = `0000${account}`;
      break;
    case 2:
      acc_no = `000${account}`;
      break;
    case 3:
      acc_no = `00${account}`;
      break;
    case 4:
      acc_no = `0${account}`;
      break;
    default:
      acc_no = `${account}`;
  }

  if (account === undefined) {
    return [];
  }
  const result = await fetch(`https://vms.toyota.co.tz/statements/${acc_no}`);
  const transactions = await result.json();
  return transactions;
};

export default fetchStatement;
